import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLanguageSwitchStyle } from "./styles";
import { LanguageSelector } from "./selector/LanguageSelector";
import { useLanguageSwitch } from "./hooks/useLanguageSwitch";
import { AccordionWithoutGap } from "../../../utils/styled";
import { useTranslation } from "react-i18next";

export const LanguageSwitch = () => {
  const styles = useLanguageSwitchStyle();
  const { t } = useTranslation("common");
  const { supportedLanguages, onLanguageChange, selectedLanguage, getFlagByLanguage, handleAccordionChange, accordionExpanded } =
    useLanguageSwitch();

  return (
    <div>
      <AccordionWithoutGap data-testid="language-accordion" expanded={accordionExpanded} onChange={handleAccordionChange} elevation={0}>
        <AccordionSummary sx={{ padding: '0 12px' }} expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <div className={styles.headerContainer}>
            {getFlagByLanguage(selectedLanguage.code)}
            <span className={styles.title}>{selectedLanguage.title}</span>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <span className={styles.summaryTitle}>{t("header.languages.selectLanguage")}</span>
          <LanguageSelector selectedLanguage={selectedLanguage} onLanguageChange={onLanguageChange} options={supportedLanguages} />
        </AccordionDetails>
      </AccordionWithoutGap>
    </div>
  );
};
